// @flow
import * as React from 'react';
import { connect } from 'react-redux';

import ShareIcon from 'mz-icons/share';
import TextField from 'mz-ui-kit/form/TextField/field';
import EmailField, { EMAIL_REGEXP } from 'mz-ui-kit/form/EmailField';
import Button from 'mz-ui-kit/core/Button';
import SelectorButton from 'mz-ui-kit/core/SelectorButton';
import clipboardCopy from 'mz-utils/clipboardCopy';
import { shareResultEmail, copyResultURL } from 'app/actions/search-results';

import { FormattedMessage } from 'translations';

import { ButtonSpacer, ShareContainer, Title, HideMobile, IconSpace } from './elements';

const messages = {
  shareResults: { id: 'SEARCH_RESULTS.SHARE_RESULTS' },
  shareResultsTitle: { id: 'SEARCH_RESULTS.SHARE_RESULTS_TITLE' },
  shareButton: { id: 'SEARCH_RESULTS.SHARE' },
  shareLink: { id: 'SEARCH_RESULTS.SHARE_LINK' },
  shareEmail: { id : 'SEARCH_RESULTS.SHARE_VIA_EMAIL' },
  enterEmail: { id: 'SEARCH_RESULTS.ENTER_EMAIL' },
  copyLink: { id: 'SEARCH_RESULTS.COPY_LINK' }
};

function Share ({ shareResultEmail, copyResultURL }) {
  const [useEmail, setEmail] = React.useState('');

  const handleClickShare = () => {
    window.open(`mailto:${useEmail}?subject=Mozio Search Result&body=${encodeURIComponent(window.location.href)}`, '_blank');
    shareResultEmail();
  }

  const handleClickCopy = close => () => {
    clipboardCopy(window.location.href);
    copyResultURL();
    close();
  }

  return (
    <SelectorButton
      mobileTitle="Share Results"
      placement='bottom-end'
      width='435px'
      renderButton={({ open }) => (
        <ButtonSpacer>
          <Button
            color='secondary'
            onClick={open}>
            <IconSpace><ShareIcon /></IconSpace>
            <FormattedMessage {...messages.shareResults} />
          </Button>
        </ButtonSpacer>
      )}
      renderSelector={({ close }) => (
        <ShareContainer>
          <HideMobile>
            <Title><FormattedMessage {...messages.shareResultsTitle} /></Title>
          </HideMobile>
          <TextField
            appearance='material'
            input={{
              value: window.location.href,
              readOnly: true
            }}
            label={<FormattedMessage {...messages.shareLink} />}
          />
          <br />
          <Button
            color='secondary'
            onClick={handleClickCopy(close)}><FormattedMessage {...messages.copyLink} /></Button>

          <EmailField
            input={{
              value: useEmail,
              onChange: setEmail
            }}
            appearance='material'
            placeholder={<FormattedMessage {...messages.enterEmail} />}
            label={<FormattedMessage {...messages.shareEmail} />}
          />
          <br />
          <Button
            color='secondary'
            disabled={!EMAIL_REGEXP.test(useEmail)}
            fullWidth
            onClick={handleClickShare}><FormattedMessage {...messages.shareButton} />
          </Button>
        </ShareContainer>
      )}
    />
  )
}

export default connect(null, { copyResultURL, shareResultEmail })(Share);
